import { createSelector } from 'reselect'

import { selectSiteBuilderState } from 'core-components/sitebuilder/store/selectors/selectSitebuilderSelectors'

export const selectAppId = createSelector([selectSiteBuilderState], ({ app }) => app.id)
